/** ตัด tag HTML ออกเหลือแต่ข้อความล้วน — ใช้กับบริบทที่ไม่ต้องการ/แสดง markup ไม่ได้ (ป้ายชื่อย่อ, filename, ข้อความยืนยัน, tooltip)
 *  form_name/form_desc/page_name/page_desc เก็บเป็น HTML จาก rich text editor แล้ว จุดที่ไม่ได้ render ผ่าน [innerHTML] ต้องผ่านฟังก์ชันนี้ก่อนเสมอ กัน tag ดิบหลุดไปโชว์ตรง ๆ */
export function stripHtml(html: string | null | undefined): string {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').trim();
}
